function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { withTheme } from '../../core/theming';

const Card = props => {
  const {
    children,
    theme,
    onPress,
    isShadowDisplayed = true,
    style,
    accessibility,
    activeOpacity
  } = props;
  const customStyles = [styles.container, {
    backgroundColor: theme.colors.background.white,
    ...(isShadowDisplayed ? {
      boxShadow: '0px 2px 4px rgba(84, 107, 132, 0.1)',
      ...styles.nativeShadow
    } : {})
  }, style];
  return typeof onPress === 'function' ? /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
    accessibilityRole: 'button'
  }, accessibility, {
    onPress: onPress,
    style: customStyles,
    activeOpacity: activeOpacity
  }), children) : /*#__PURE__*/React.createElement(View, _extends({}, accessibility, {
    style: customStyles
  }), children);
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 32,
    paddingVertical: 24,
    borderRadius: 2
  },
  nativeShadow: {
    shadowColor: 'rgba(84, 107, 132, 1)',
    shadowOffset: {
      width: 0,
      height: 1
    },
    shadowOpacity: 0.2,
    shadowRadius: 2.22,
    elevation: 3
  }
});
export default withTheme(Card);
//# sourceMappingURL=index.js.map